/**
 * Converts product description sections with <p> + <strong>/<b> headings into collapsible tabs.
 * Only affects paragraphs where the leading content is <strong> or <b>.
 */
(function() {
  const DEBUG = false;

  function init() {
    const containers = document.querySelectorAll('.product__description.rte');
    if (DEBUG) console.log('[Product Accordion] init() – found containers:', containers.length);

    containers.forEach((container) => {
      if (container.querySelector('.product__description-accordion')) {
        if (DEBUG) console.log('[Product Accordion] Skipping – already has accordions');
        return;
      }

      const sections = [];
      let preContent = [];
      const children = Array.from(container.children);
      const headingSelector = 'strong, b';

      if (DEBUG) {
        console.log('[Product Accordion] Container children:', children.length);
        children.forEach((c, idx) => {
          const headingEl = c.tagName === 'P' ? c.querySelector(headingSelector) : null;
          const isLeading = headingEl ? isLeadingContent(c, headingEl) : false;
          const preview = (c.innerHTML || '').slice(0, 70);
          console.log(`  [${idx}] ${c.tagName}.${c.className || ''} heading:${!!headingEl} isLeading:${isLeading}`, preview);
        });
      }

      let i = 0;

      while (i < children.length) {
        const el = children[i];
        const headingEl = el.tagName === 'P' && el.querySelector(headingSelector);
        const isLeading = headingEl && isLeadingContent(el, headingEl);
        const isHeadingPara = isLeading;
        if (DEBUG && headingEl && !isLeading) {
          console.log('[Product Accordion] P has strong/b but not leading:', headingEl.textContent?.slice(0, 30), '| innerHTML:', el.innerHTML?.slice(0, 80));
        }

        if (isHeadingPara) {
          const headingText = headingEl.textContent.trim();
          if (DEBUG) console.log('[Product Accordion] Heading para found:', headingText);
          if (!headingText) {
            i++;
            continue;
          }

          const contentNodes = [];
          const afterBold = getContentAfterBold(el);
          if (afterBold && afterBold.childNodes.length) {
            contentNodes.push(afterBold);
          }

          i++;
          while (i < children.length) {
            const next = children[i];
            const nextHeading = next.tagName === 'P' && next.querySelector(headingSelector);
            const nextIsHeading = nextHeading && isLeadingContent(next, nextHeading);
            if (nextIsHeading) break;
            contentNodes.push(next.cloneNode(true));
            i++;
          }

          sections.push({ heading: headingText, content: contentNodes });
        } else {
          preContent.push(el.cloneNode(true));
          i++;
        }
      }

      if (sections.length === 0) {
        if (DEBUG) console.log('[Product Accordion] No heading sections found – exiting');
        return;
      }

      if (DEBUG) console.log('[Product Accordion] Building accordions for sections:', sections.map((s) => s.heading));

      const fragment = document.createDocumentFragment();
      preContent.forEach(node => fragment.appendChild(node));

      sections.forEach((section, idx) => {
        const details = document.createElement('details');
        details.className = 'product__description-accordion accordion';
        details.id = 'ProductDescriptionAccordion-' + idx;

        const summary = document.createElement('summary');
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', 'false');

        const summaryTitle = document.createElement('div');
        summaryTitle.className = 'summary__title';
        const title = document.createElement('h2');
        title.className = 'h4 accordion__title';
        title.textContent = section.heading;
        summaryTitle.appendChild(title);

        const iconCaretSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        iconCaretSvg.setAttribute('class', 'icon icon-caret');
        iconCaretSvg.setAttribute('viewBox', '0 0 10 6');
        iconCaretSvg.innerHTML = '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/>';

        summary.appendChild(summaryTitle);
        summary.appendChild(iconCaretSvg);

        const contentDiv = document.createElement('div');
        contentDiv.className = 'accordion__content rte';
        section.content.forEach(node => contentDiv.appendChild(node));

        details.appendChild(summary);
        details.appendChild(contentDiv);
        fragment.appendChild(details);
      });

      container.innerHTML = '';
      container.appendChild(fragment);
    });

    setupAccordionAnimations();
  }

  function setupAccordionAnimations() {
    document.querySelectorAll('.product__accordion details, .product__description-accordion').forEach((details) => {
      if (details.hasAttribute('data-accordion-initialized')) return;
      details.setAttribute('data-accordion-initialized', '');
      details.addEventListener('toggle', () => {
        details.classList.toggle('is-open', details.open);
      });
      if (details.open) details.classList.add('is-open');
    });
  }

  function isLeadingContent(parent, strongEl) {
    let node = parent.firstChild;
    while (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.trim()) return false;
      } else if (node === strongEl) {
        return true;
      } else if (node.contains && node.contains(strongEl)) {
        return true;
      } else {
        return false;
      }
      node = node.nextSibling;
    }
    return false;
  }

  function getContentAfterBold(pEl) {
    const boldEl = pEl.querySelector('strong, b');
    if (!boldEl) return null;
    const clone = pEl.cloneNode(true);
    const boldClone = clone.querySelector('strong, b');
    if (!boldClone) return null;
    removeNodeAndPreceders(boldClone);
    const wrapper = document.createElement('div');
    while (clone.firstChild) wrapper.appendChild(clone.firstChild);
    return wrapper.childNodes.length ? wrapper : null;
  }

  function removeNodeAndPreceders(node) {
    const parent = node.parentNode;
    if (!parent) return;
    const siblings = Array.from(parent.childNodes);
    const idx = siblings.indexOf(node);
    for (let i = 0; i <= idx; i++) {
      siblings[i].remove();
    }
    if (parent.parentNode && parent !== node.ownerDocument.body && !parent.childNodes.length) {
      removeNodeAndPreceders(parent);
    }
  }

  function runWhenReady() {
    if (DEBUG) console.log('[Product Accordion] Script loaded, readyState:', document.readyState);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  runWhenReady();
  if (DEBUG) console.log('[Product Accordion] Listening for product-info:loaded');

  document.addEventListener('product-info:loaded', () => {
    if (DEBUG) console.log('[Product Accordion] product-info:loaded fired');
    setTimeout(init, 0);
  });

  const productInfo = document.querySelector('product-info');
  if (productInfo) {
    let debounceTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(init, 100);
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }
})();
